import { useAdminStore } from '@getmayday/vue-modules';

const useExternalRedirection = () => {
  const adminStore = useAdminStore();
  const { accessToken, subdomainUrl, accessExpirationDate, company } =
    storeToRefs(adminStore);

  const frontUrl = computed(() => {
    if (company.value?.subdomain === 'app' || !subdomainUrl.value)
      return import.meta.env.VITE_APP_FRONT_URL as string;
    return subdomainUrl.value;
  });

  function webUrl(path: string) {
    return new URL(path, frontUrl.value).href;
  }

  const entityUrl = ({
    entityId,
    entityType,
    entityAncestors,
    lang,
  }: {
    entityId: string;
    entityType: string;
    entityAncestors: string | null;
    lang: string;
  }) => {
    const type = !entityType || entityType === 'Case' ? 'case' : 'content';

    if (entityAncestors) {
      return `/web/${lang}/content/${
        entityAncestors.split('/')[0]
      }/step/${entityId}`;
    }

    return `/web/${lang}/${type}/${entityId}`;
  };

  function redirectUrl(url: string) {
    if (accessToken.value === null) return null;

    const redirectUrl = new URL('/redirect', frontUrl.value);
    redirectUrl.searchParams.set('redirect', url);
    redirectUrl.searchParams.set('sso_token', accessToken.value);
    redirectUrl.searchParams.set(
      'accessExpirationDate',
      String(accessExpirationDate.value),
    );
    return redirectUrl.href;
  }

  return { redirectUrl, webUrl, entityUrl };
};

export default useExternalRedirection;
